<template>
  <div class="box">
    <div class="box-bg">
      <div>
        <img
          :src="user.pictureBase64 ? user.pictureBase64 : defaultPic"
          alt=""
          class="img"
          style="width: 80px; height: 80px"
        />
      </div>
      <div>{{ user.username }}</div>
    </div>

    <div class="content-box">
      <div v-for="(item, index) in list" :key="index">
        <div
          @click="handleSkip(item.path)"
          class="list-item"
          :style="{
            backgroundColor: `${['#fefaf2', '#EFF9F7', '#F2F6FE', '#FDF4F4', '#F0F9FF'][item.id - 1]}`,
          }"
        >
          <div class="choose" v-if="item.show">
            <img width="23px" height="23px" :src="item.show == 1 ? choose : closebtn" />
          </div>
          <div>
            <img :width="item.id == 3 ? '25px' : '30px'" height="30px" :src="item.icon" />
          </div>
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="quit" @click="handleQuit">{{ $t("base.btn.logout") }}</div>
  </div>
</template>

<script>
import defaultPic from "@/assets/mAssets/home/tou_none_icon.png";
import xgyhm from "@/assets/mAssets/home/xgyhm.png";
import xgmm from "@/assets/mAssets/home/xgmm.png";
import sjbd from "@/assets/mAssets/home/sjbd.png";
import yxbd from "@/assets/mAssets/home/yxbd.png";
import sfbd from "@/assets/mAssets/home/sfbd.png";
import choose from "@/assets/mAssets/home/choose.png";
import closebtn from "@/assets/mAssets/home/closebtn.png";
import { commonAPI } from "@/apis";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      choose,
      closebtn,
      defaultPic,
      list: [
        // { id: 1, name: "修改别名", icon: xgyhm, path: "/mchangeName" },
        { id: 2, name: this.$t("webapp.home.update_password"), icon: xgmm, path: "/mpassword", show: null },
        { id: 3, name: this.$t("webapp.home.bind_mobile"), icon: sjbd, path: "/mbindPhone", show: null },
        { id: 4, name: this.$t("webapp.home.bind_email"), icon: yxbd, path: "/mbindEmail", show: null },
        { id: 5, name: this.$t("webapp.home.bind_account"), icon: sfbd, path: "/mbindIdentity", show: null },
      ],
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  created() {
    this.getUserInfo();
    this.getBasicSet();
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      const { code, data } = await commonAPI.getAction(`/users/getUserInfo/${this.user.username}`);
      if (code == 0) {
        let userInfo = JSON.parse(sessionStorage.getItem("user"));
        let obj = Object.assign(userInfo, data || {});
        this.$store.commit("auth/setSessionUser", obj);
        this.list.map((v) => {
          if ((v.id == 1 && obj.alias) || (v.id == 3 && obj.mobile) || (v.id == 4 && obj.email)) {
            v.show = 1;
          } else if (v.id == 2 || v.id == 5) {
            v.show = null;
          } else {
            v.show = 2;
          }
        });
      }
    },
    // 获取基础配置
    async getBasicSet() {
      const { code, data, message } = await commonAPI.getAction("setting/basic/get");
      if (code == 0) {
        let obj = { ...data };
        this.basicSetInfo = obj;
        sessionStorage.setItem("BASIC_SET_INFO", JSON.stringify(obj));
        if (this.basicSetInfo.sfqybm == 1) {
          this.list.unshift({
            id: 1,
            name: this.$t("webapp.home.edit_alias"),
            icon: xgyhm,
            path: "/mchangeName",
            show: null,
          });
        }
      } else {
        toast(message);
      }
    },
    handleSkip(path) {
      this.$router.push({ path: path });
    },
    async handleQuit() {
      const { code } = await commonAPI.getAction("/logout");
      console.log(code);
      let language = localStorage.getItem("language");
      localStorage.clear();
      if (language) {
        localStorage.setItem("language", language);
      }
      sessionStorage.clear();
      this.$router.replace("/mlogin");
    },
    onSubmit(values) {
      console.log("submit", values, this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 26px;
  height: 100vh;
  .box-bg {
    width: 100%;
    padding: 50px 0;
    background-image: url("~@/assets/mAssets/home/homebg.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    font-weight: 600;
    .img {
      border-radius: 50px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.11);
      // border: 3px solid rgba(255, 255, 255, 0.62);
    }
  }
  .content-box {
    font-size: 14px;
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 15px;
    .list-item {
      color: #333333;
      border-radius: 5px;
      background-color: #fefaf2;
      padding: 15px;
      position: relative;
      .choose {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  .quit {
    margin: 30px 15px;
    line-height: 40px;
    background: orange;
    color: #fff;
    border-radius: 20px;
  }
}
</style>
